import { useCallback, useState } from 'react';
import { clsx } from 'clsx';
import { useCurrentRoomContext } from 'pages/CurrentRoom/context';
import { VideoProps } from './interface';
import { Trans } from '@lingui/macro';
import Typography from '@mui/material/Typography';
import CustomModal from 'components/organisms/CustomModal';
import alignStyles from 'shared/styles/alignment.module.css';
import styles from './video.module.css';
import SkipNextSharpIcon from '@mui/icons-material/SkipNextSharp';

export default function Video(props: VideoProps) {
  const { videoUrl } = props;
  const { collapsedSidebar } = useCurrentRoomContext();
  const [videoModalShow, setVideoModalShow] = useState<boolean>(false);

  const videoClassNames = clsx(styles.video, collapsedSidebar && alignStyles['flex-center']);

  const closeVideoModal = useCallback(() => {
    setVideoModalShow(false);
  }, []);

  const handleClick = useCallback(() => {
    setVideoModalShow(true);
  }, []);

  return (
    <>
      <CustomModal backdrop onClose={closeVideoModal} show={videoModalShow} closeButton>
        <div>
          <Typography
            id="modal-modal-title"
            className={styles.video__title}
            variant="h6"
            component="h2"
          >
            <Trans id="fileExplorer.video" />
          </Typography>
          <iframe src={videoModalShow ? videoUrl : ''} width="853" height="480" />
        </div>
      </CustomModal>
      <div className={videoClassNames} onClick={handleClick}>
        <SkipNextSharpIcon />
        {!collapsedSidebar && (
          <span className={styles.video__content}>
            <Trans id="fileExplorer.video" />
          </span>
        )}
      </div>
    </>
  );
}
